import { CalendarEvent } from 'owa-calendar-types';

export default function shouldOpenInCompose(item: CalendarEvent): boolean {
    // Only check for MeetingRequestWasSent if notifications result in it being updated
    return !!(item.IsMeeting && item.IsOrganizer && (item.IsDraft || !item.MeetingRequestWasSent));
}
